import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';
import frontendUtils from '../../../utils/frontendUtils';

export default function GeneralAuthModal() {
  const contactUsUrl = frontendUtils.getContactUsUrl('app-auth', 'sales');

  return (
    <Modal dialogClassName="app-auth-modal" show={true}>
      <Modal.Header>
        <Modal.Title>
          <Trans i18nKey="account.has.been.blocked.title">
            Your account has been blocked
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Trans i18nKey="account.has.been.blocked.desc">
            Your account has been blocked because unusual activity was detected.
            If you have any questions, you can{' '}
            <a
              href={contactUsUrl}
              rel="noreferrer noopener"
              className="kt-link"
            >
              contact us
            </a>
            .
          </Trans>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <a href={contactUsUrl} className="btn btn-primary">
          <Trans i18nKey="account.has.been.blocked.ok">OK</Trans>
        </a>
      </Modal.Footer>
    </Modal>
  );
}
